// extracted by mini-css-extract-plugin
export default {"container":"Button_container__aKtNe","Main":"Button_Main__ZMnB8","Square":"Button_Square__z7Znk"};